import * as React from "react";
import IconWrapper from "./IconWrapper";
import {IconVariant} from "./Icon";

interface IProps {
	/**
	 * Icon name.
	 */
	icon: string;
	/**
	 * Icon variant
	 */
	variant?: IconVariant;
	/**
	 * On Click handler
	 */
	onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Transform function.
	 */
	transform?: string;
}

export default class IconLarge extends React.Component<IProps, {}> {
	render() {
		return (
			<IconWrapper
				size={24}
				icon={this.props.icon}
				onClick={this.props.onClick}
				variant={this.props.variant}
				transform={this.props.transform}/>
		);
	}
}
